import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormTypeToSelect from '../form/FormTypeToSelect';
import EquipmentContainer from '../../containers/Equipment';
import EquipmentAssignmentContainer from '../../containers/EquipmentAssignment';
import UserAssignmentContainer from '../../containers/UserAssignment';
import { getAssignmentBreakdowns } from '../assignments/assignmentHelper';
import { getUserAssignmentType } from '../../libs/user';
import Grid from '@material-ui/core/Grid';
import moment from 'moment-timezone';

class EquipmentSelect extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			assignmentBreakdowns: undefined,
		};
	}

	componentDidMount() {
		const {
			equipments,
			searchEquipments,
			equipmentAssignments,
			searchEquipmentAssignments,
			userAssignments,
			searchUserAssignments,
			groupBy,
		} = this.props;

		if (_.isEmpty(equipments)) {
			searchEquipments();
		}

		if (
			_.isEmpty(equipmentAssignments) &&
			(groupBy === 'currentlyAssignedOrUnassigned' || groupBy === 'locations')
		) {
			searchEquipmentAssignments();
		}

		if (groupBy === 'availableAtTerminal') {
			if (_.isEmpty(equipmentAssignments)) {
				searchEquipmentAssignments();
			}

			if (_.isEmpty(userAssignments)) {
				searchUserAssignments();
			}
		}

		const { assignmentBreakdowns } = this.state;
		if (
			!_.isEmpty(userAssignments) &&
			!_.isEmpty(equipmentAssignments) &&
			_.isUndefined(assignmentBreakdowns)
		) {
			this.formatAssignmentBreakdowns();
		}
	}

	componentDidUpdate(_prevProps, _prevState, _snapShot) {
		const { userAssignments, equipmentAssignments } = this.props;

		const { assignmentBreakdowns } = this.state;
		if (
			!_.isEmpty(userAssignments) &&
			!_.isEmpty(equipmentAssignments) &&
			_.isUndefined(assignmentBreakdowns)
		) {
			this.formatAssignmentBreakdowns();
		}
	}

	formatAssignmentBreakdowns = () => {
		const { userMap, locationMap, userAssignments, equipmentAssignments } = this.props;

		const { assignmentBreakdowns } = getAssignmentBreakdowns({
			userMap,
			locationMap,
			userAssignments,
			equipmentAssignments,
		});

		this.setState({
			assignmentBreakdowns,
		});
	};

	render() {
		const {
			equipments,
			groupBy,
			filterType,
			selectedLocationId,
			selectedShiftId,
			selectedUserAssignmentTypeId,
			selectedCTypeTruckNumber,
			equipmentMap,
			locationMap,
			includeTbd,
			onlyShowActive,
			currentUserAssignmentId,
		} = this.props;

		const { assignmentBreakdowns } = this.state;

		let options = [];
		if (groupBy === 'currentlyAssignedOrUnassigned') {
			const { equipmentAssignments = [] } = this.props;

			const assignmentMap = _.keyBy(equipmentAssignments, 'equipmentId');

			const unassigned = { label: 'Unassigned Trucks', options: [] };
			const assigned = { label: 'Assigned Trucks', options: [] };

			_.sortBy(equipments, 'display').forEach((equipment) => {
				const { display, equipmentId, geoTabComment, status } = equipment;

				if (onlyShowActive && status === 'retired') {
					return;
				}

				const option = {
					value: equipmentId,
					label: `${display} - (${geoTabComment})`,
				};

				if (assignmentMap[equipmentId]) {
					if (filterType !== 'showOnlyUnassigned') {
						assigned.options.push(option);
					}
				} else {
					unassigned.options.push(option);
				}
			});
			options.push(unassigned, assigned);
		} else if (groupBy === 'availableAtTerminal') {
			if (_.isEmpty(assignmentBreakdowns)) {
				return <div>Fetching breakdowns..</div>;
			}

			if (!selectedLocationId || !selectedShiftId || !selectedUserAssignmentTypeId) {
				return (
					<Grid item xs={12}>
						<div
							style={{
								padding: 20,
								background: '#f7f7f7',
								border: '1px solid #ddd',
								color: '#333',
							}}
						>
							Select location,shift, schedule for available equipments.
						</div>
					</Grid>
				);
			}

			const unassigned = { label: 'Available trucks for shift/schedule', options: [] };
			const assigned = { label: 'Currently assigned to this driver', options: [] };

			assignmentBreakdowns.forEach((assignmentBreakdown) => {
				const { location, shiftRows } = assignmentBreakdown;
				const { locationId } = location;

				if (locationId !== selectedLocationId) {
					return;
				}

				shiftRows.forEach((shiftRow) => {
					const { shiftId, scheduleStatRows, availableARows, availableCRows } = shiftRow;

					if (selectedShiftId !== shiftId) {
						return;
					}

					const userAssignmentType = getUserAssignmentType({
						userAssignmentTypeId: selectedUserAssignmentTypeId,
					});

					let availableRows;
					if (userAssignmentType.isTypeC) {
						availableRows = availableCRows || [];
					} else {
						availableRows = availableARows || [];
					}

					availableRows.forEach((availableRow) => {
						const { equipmentId, shiftTime, canBeATruck, canBeBTruck } = availableRow;
						const equipment = equipmentMap[equipmentId] || { display: 'Missing' };
						const { display, geoTabComment, status } = equipment;
						if (onlyShowActive && status === 'retired') {
							return;
						}

						let shiftTimeDisplay;
						let isDecommissioned = false;
						if (!shiftTime) {
							isDecommissioned = true;
							shiftTimeDisplay = ' ? ';
						} else {
							shiftTimeDisplay = moment(shiftTime, 'HH:mm:ss').format('h:mm a');
						}

						let label = `${shiftTimeDisplay} - ${display} (${geoTabComment})`;
						if (isDecommissioned) {
							label += `(decommissioned)`;
						}

						const option = { value: equipmentId, label };

						if (userAssignmentType.isTypeA && canBeATruck) {
							unassigned.options.push(option);
						} else if (userAssignmentType.isTypeB && canBeBTruck) {
							unassigned.options.push(option);
						} else if (userAssignmentType.isTypeC) {
							if (selectedCTypeTruckNumber === 'first' && canBeATruck) {
								unassigned.options.push(option);
							} else if (selectedCTypeTruckNumber === 'second' && canBeBTruck) {
								unassigned.options.push(option);
							}
						}
					});

					unassigned.options = _.sortBy(unassigned.options, 'label');

					scheduleStatRows.forEach((scheduleStatRow) => {
						const { list } = scheduleStatRow;

						list.forEach((row) => {
							const { userAssignment, shiftTime } = row;
							if (!userAssignment) {
								return;
							}
							const { equipmentIds, userAssignmentId } = userAssignment;
							if (currentUserAssignmentId !== userAssignmentId) {
								return;
							}

							const index = selectedCTypeTruckNumber === 'second' ? 1 : 0;
							const equipmentId = equipmentIds[index];

							const equipment = equipmentMap[equipmentId] || { display: 'Missing' };
							const { display, geoTabComment, status } = equipment;
							if (onlyShowActive && status === 'retired') {
								return;
							}

							let shiftTimeDisplay;
							let isDecommissioned = false;
							if (!shiftTime) {
								isDecommissioned = true;
								shiftTimeDisplay = ' ? ';
							} else {
								shiftTimeDisplay = moment(shiftTime, 'HH:mm:ss').format('h:mm a');
							}

							let label = `${shiftTimeDisplay} - ${display} (${geoTabComment})`;
							if (isDecommissioned) {
								label += `(decommissioned)`;
							}
							const option = { value: equipmentId, label };
							assigned.options.push(option);
						});
					});
				});
			});

			options.push(unassigned, assigned);
			//options.push(unassigned);
		} else if (groupBy === 'allAtTerminal') {
			if (_.isEmpty(assignmentBreakdowns)) {
				return <div>Fetching breakdowns..</div>;
			}

			if (!selectedLocationId || !selectedShiftId || !selectedUserAssignmentTypeId) {
				return (
					<Grid item xs={12}>
						<div
							style={{
								padding: 20,
								background: '#f7f7f7',
								border: '1px solid #ddd',
								color: '#333',
							}}
						>
							Select location,shift, schedule for available equipments.
						</div>
					</Grid>
				);
			}

			const assigned = { label: 'Currently assigned to this driver', options: [] };
			const unassigned = { label: 'Available trucks for shift/schedule', options: [] };
			const other = { label: 'All other trucks at terminal for shift', options: [] };

			assignmentBreakdowns.forEach((assignmentBreakdown) => {
				const { location, shiftRows } = assignmentBreakdown;
				const { locationId } = location;

				if (locationId !== selectedLocationId) {
					return;
				}

				shiftRows.forEach((shiftRow) => {
					const { shiftId, scheduleStatRows, availableCRows, availableARows } = shiftRow;

					if (selectedShiftId !== shiftId) {
						return;
					}

					const alreadySeen = {};

					const userAssignmentType = getUserAssignmentType({
						userAssignmentTypeId: selectedUserAssignmentTypeId,
					});

					let availableRows;
					if (userAssignmentType.isTypeC) {
						availableRows = availableCRows || [];
					} else {
						availableRows = availableARows || [];
					}

					availableRows.forEach((availableRow) => {
						const { equipmentId, shiftTime, canBeATruck, canBeBTruck } = availableRow;
						const equipment = equipmentMap[equipmentId] || { display: 'Missing' };
						const { display, geoTabComment, status } = equipment;
						if (onlyShowActive && status === 'retired') {
							return;
						}

						let shiftTimeDisplay;
						let isDecommissioned = false;
						if (!shiftTime) {
							isDecommissioned = true;
							shiftTimeDisplay = ' ? ';
						} else {
							shiftTimeDisplay = moment(shiftTime, 'HH:mm:ss').format('h:mm a');
						}

						let label = `${shiftTimeDisplay} - ${display} (${geoTabComment})`;
						if (isDecommissioned) {
							label += `(decommissioned)`;
						}

						const option = { value: equipmentId, label };

						if (userAssignmentType.isTypeA && canBeATruck) {
							unassigned.options.push(option);
						} else if (userAssignmentType.isTypeB && canBeBTruck) {
							unassigned.options.push(option);
						} else if (userAssignmentType.isTypeC) {
							if (selectedCTypeTruckNumber === 'first' && canBeATruck) {
								unassigned.options.push(option);
							} else if (selectedCTypeTruckNumber === 'second' && canBeBTruck) {
								unassigned.options.push(option);
							}
						}
					});

					unassigned.options = _.sortBy(unassigned.options, 'label');

					scheduleStatRows.forEach((scheduleStatRow) => {
						const { list } = scheduleStatRow;

						list.forEach((row) => {
							const { userAssignment, shiftTime } = row;
							if (!userAssignment) {
								console.log('SKIPPING ROW', row);
								return;
							}
							const { equipmentIds } = userAssignment;

							equipmentIds.forEach((equipmentId) => {
								if (alreadySeen[equipmentId]) {
									return;
								}
								alreadySeen[equipmentId] = true;
								const equipment = equipmentMap[equipmentId] || { display: 'Is Missing' };
								const { display, geoTabComment, status } = equipment;
								if (onlyShowActive && status === 'retired') {
									return;
								}

								let shiftTimeDisplay;
								let isDecommissioned = false;
								if (!shiftTime) {
									isDecommissioned = true;
									shiftTimeDisplay = ' ? ';
								} else {
									shiftTimeDisplay = moment(shiftTime, 'HH:mm:ss').format('h:mm a');
								}

								let label = `${shiftTimeDisplay} - ${display} (${geoTabComment})`;
								if (isDecommissioned) {
									label += `(decommissioned)`;
								}

								const option = { value: equipmentId, label };
								other.options.push(option);
							});
						});
					});
				});
			});

			other.options = _.sortBy(other.options, 'label');

			options.push(unassigned, other, assigned);
		} else if (groupBy === 'locations') {
			const { openTrucks = [], equipmentAssignments = [], groupByLocationIds = [] } = this.props;
			const openTruckOptionGroup = { label: 'Open Trucks', options: [] };

			if (_.isEmpty(equipmentMap) || _.isEmpty(equipmentAssignments)) {
				return <div>Fetching breakdowns..</div>;
			}

			openTrucks.forEach(({ equipmentId }) => {
				const equipment = equipmentMap[equipmentId] || { display: 'Missing' };
				const { display, geoTabComment } = equipment;
				openTruckOptionGroup.options.push({
					value: equipmentId,
					label: `${display} - (${geoTabComment})`,
				});
			});

			if (includeTbd) {
				options.push({
					label: 'To Be Determined',
					options: [{ label: 'To be determined (TBD)', value: 'tbd' }],
				});
			}

			options.push(openTruckOptionGroup);

			//- XXX added to api to single locationId
			const byLocation = _.groupBy(equipmentAssignments, 'locationId');

			const alreadySeen = {};
			groupByLocationIds.forEach((locationId) => {
				const location = locationMap[locationId] || { display: 'Missing Terminal' };
				const optionGroup = {
					label: `All trucks at ${location.display}`,
					options: [],
				};

				if (_.isEmpty(byLocation[locationId])) {
					return;
				}

				byLocation[locationId].forEach((equipmentAssignment) => {
					const { equipmentId } = equipmentAssignment;
					if (alreadySeen[equipmentId]) {
						return;
					}
					alreadySeen[equipmentId] = true;

					const equipment = equipmentMap[equipmentId] || { display: 'Missing' };
					const { display, geoTabComment } = equipment;
					optionGroup.options.push({
						value: equipmentId,
						label: `${display} - (${geoTabComment})`,
					});
				});

				options.push(optionGroup);
			});
		} else {
			options = equipments.map((equipment) => {
				const { display, equipmentId, geoTabComment } = equipment;
				return {
					value: equipmentId,
					label: `${display} - (${geoTabComment})`,
				};
			});
			options = _.sortBy(options, 'label');
		}

		return <FormTypeToSelect {...this.props} options={options} />;
	}
}

EquipmentSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,
	currentUserAssignmentId: PropTypes.number,

	classes: PropTypes.object,
	helpText: PropTypes.string,
	groupBy: PropTypes.string,
	filterType: PropTypes.string,
	openTrucks: PropTypes.array,
	includeTbd: PropTypes.bool,
	onlyShowActive: PropTypes.bool,
};

EquipmentSelect.defaultProps = {
	label: 'Equipment',
	equipments: [],
	includeTbd: false,
	onlyShowActive: false,
};

export default _.flow([EquipmentAssignmentContainer, UserAssignmentContainer, EquipmentContainer])(
	EquipmentSelect
);
